(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
  class LanguageSelect extends HTMLElement {
    constructor() {
      super();

      this.btn = this.querySelectorAll('a');

      this.btn.forEach(el=>{
        if (el.dataset.lang == Shopify.locale) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });

      this.btn.forEach(el=>{
        el.addEventListener('click', ()=>this.update(el));
      })

    }

    update(cur) {
      this.btn.forEach(el=>{
        if (el == cur) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });
    }
  }
  customElements.define('language-select', LanguageSelect);
  */


  class HeaderMenuDesktop extends HTMLElement {
    constructor() {
      super();
      this.blocksubmenu = true;

      this.init();
    }

    init() {
      this.tableCTA = this.querySelector('.tableCTA');
      this.collecCTA = this.querySelector('.collectionCTA');
      this.decoCTA = this.querySelector('.decorationCTA');
      this.tableCTN = this.querySelector('.tableTab');
      this.collecCTN = this.querySelector('.collectionTab');
      this.decoCTN = this.querySelector('.decorationTab');
      this.subMenuCtn = this.querySelector(".subMenuCtn");
      
      this.searchCtn = this.querySelector(".searchModalCtn");
      this.searchBtn = this.querySelector(".callSearchModal");

      // this.tableCTA.addEventListener('mouseenter', ()=>this.openSubMenu('table'));
      // this.collecCTA.addEventListener('mouseenter', ()=>this.openSubMenu('collection'));
      // this.addEventListener('mouseleave', ()=>this.closeSubMenu());

      if (this.searchCtn != undefined) {
        this.searchBtn.addEventListener('click', ()=>this.controlModal('search'));
      } else {
        this.searchBtn.addEventListener('click', ()=>{
          let el = document.querySelector('main .search__input');
          if (el != undefined) {
            el.focus();
          }
        });
      }
      
      if (this.tableCTA != undefined) {
        this.tableCTA.addEventListener('click', ()=>this.controlModal('table'));
        this.collecCTA.addEventListener('click', ()=>this.controlModal('collection'));
        this.decoCTA.addEventListener('click', ()=>this.controlModal('decoration'));
      }
      // this.addEventListener('mouseleave', ()=>this.closeSubMenu());

      // this.querySelectorAll('.otherLnk').forEach(el=>{
      //   el.addEventListener('mouseenter', ()=>this.closeSubMenu());
      // });
    }

    controlModal(target) {
      let close = false;
      switch(target) {
        case "table":
          if(!this.blocksubmenu) {
            return;
          }
          // this.tableCTN.classList.toggle('active');
          // this.collecCTN.classList.remove('active');
          close = (this.tableCTN.classList.contains('active'))? true : false;
          if (this.searchCtn != undefined) {
           this.searchToggle("close");
          }
        break;
        case "collection":
          if(!this.blocksubmenu) {
            return;
          }
          // this.collecCTN.classList.toggle('active');    
          // this.tableCTN.classList.remove('active');    
          close = (this.collecCTN.classList.contains('active'))? true : false;  
          if (this.searchCtn != undefined) {
           this.searchToggle("close");
          }
        break;
        case "decoration":
          if(!this.blocksubmenu) {
            return;
          }
          // this.tableCTN.classList.toggle('active');
          // this.collecCTN.classList.remove('active');
          close = (this.decoCTN.classList.contains('active'))? true : false;
          if (this.searchCtn != undefined) {
           this.searchToggle("close");
          }
        break;
        case "search":
          close = true; 
          this.searchToggle();
        break
      }
      // console.log(!this.collecCTN.classList.contains('active'), !this.collecCTN.classList.contains('active'));

      if ( close ) {
        this.closeSubMenu();
      } else {
        this.openSubMenu(target);
      }

    }

    searchToggle(ctrl) {
      if (ctrl == undefined) {
        if (this.searchCtn.classList.contains('active')) {
          this.closeModal();
        } else {
          this.openSearch();
        }
      } else {
        if(ctrl == 'open') {
          this.openSearch();
        } else {
          this.closeModal();
        }
      }
    }

    openSearch() {
      this.searchCtn.classList.add('active');
      this.searchCtn.querySelector('.search__input').focus();
    }

    closeModal() {
      this.searchCtn.classList.remove('active');
      this.searchCtn.querySelector('.search__input').blur();
    }

    openSubMenu(target) {
      this.blocksubmenu = false;
      switch(target) {
        case "table":
          // el.classList.toggle('active');
          this.tableCTN.classList.toggle('active');
          this.collecCTN.classList.remove('active');
          this.decoCTN.classList.remove('active');
        break;
        case "collection":
          // el.classList.toggle('active');
          this.collecCTN.classList.toggle('active');  
          this.tableCTN.classList.remove('active'); 
          this.decoCTN.classList.remove('active');
        break;
        case "decoration":
          // el.classList.toggle('active');
          this.decoCTN.classList.toggle('active');
          this.tableCTN.classList.remove('active');
          this.collecCTN.classList.remove('active');
        break;
      }
      setTimeout(() => {
        this.subMenuCtn.classList.add('active');
        this.blocksubmenu = true;
      }, 100);
    }

    closeSubMenu() {
      this.blocksubmenu = false;
      this.subMenuCtn.classList.remove('active');
      setTimeout(() => {
        this.tableCTN.classList.remove('active');
        this.collecCTN.classList.remove('active'); 
        this.blocksubmenu = true;
      }, 600);
    }
  }
  customElements.define('header-menu-desktop', HeaderMenuDesktop);

  class HeaderMenuMobil extends HeaderMenuDesktop {
    init() {
      this.menuCtn = this.querySelector(".menuModalCtn");
      this.menuBtn = this.querySelector(".iconNav.menuIcon");
      this.closeBtnMob = this.querySelector(".close");
      
      if (this.menuCtn != undefined) {
        this.menuBtn.addEventListener('click', ()=>this.controlModal('menu'));
      } 

      this.closeBtnMob.addEventListener('click', ()=>this.controlModal('menu'));

      this.searchCtn = this.querySelector(".searchModalCtn");
      this.searchBtn = this.querySelector(".iconNav.searchIcon");

      if (this.searchCtn != undefined) {
        this.searchBtn.addEventListener('click', ()=>this.controlModal('search'));
      } else {
        this.searchBtn.addEventListener('click', ()=>{
          let el = document.querySelector('main .search__input');
          if (el != undefined) {
            el.focus();
          }
        });
      }

    }

    controlModal(target) {
      switch(target) {
        case "menu":
          if (this.searchCtn != undefined) {
           this.toggleModal(this.searchCtn, "close");
          }
          this.toggleModal(this.menuCtn);
        break;
        case "search":
          this.toggleModal(this.menuCtn, 'close');
          this.toggleModal(this.searchCtn);
        break;
      }
    }

    toggleModal(el,ctrl) {
      if (ctrl == undefined) {
        if (el.classList.contains('active')) {
          el.classList.remove('active');
        } else {
          el.classList.add('active');
          if (el == this.searchCtn) {
            el.querySelector('.search__input').focus();
          }
        }
      } else {
        if(ctrl == 'open') {
          el.classList.add('active');
          if (el == this.searchCtn) {
            el.querySelector('.search__input').focus();
          }
        } else {
          el.classList.remove('active');
        }
      }
    }

  }
  customElements.define('header-menu-mobil', HeaderMenuMobil);
    
  class AutoSelect extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('select');
      this.form = this.querySelector('form');

      this.select.addEventListener('change', ()=>this.update());
    }
    update() {
      this.form.submit();
    }
  }
  customElements.define('auto-select', AutoSelect);

  class BottomBar extends HTMLElement {
    constructor() {
      super();
      
      this.previousScroll = window.scrollY;

      window.addEventListener('scroll', ()=>this.scroll());
    }

    scroll() {
      
      if (window.scrollY < this.previousScroll) {
        if (!this.locked) {
          this.classList.add('show');
        }
      } else {
        this.hide();
      }
      
      this.previousScroll = window.scrollY;

    }

    hide() {
      this.classList.remove('show');
    }

    lock(bool) {
      console.log(bool);
      if (bool) {
        this.locked = true;
      } else {
        this.locked = false;
      }

    }


  }
  customElements.define('bottom-bar', BottomBar);


  // class HeaderMenu extends HTMLElement {
  //   //   constructor() {
  //   //     super();
  //   //   }

  //   //   connectedCallback() {
  //   //     this.header = document.getElementById('shopify-section-header');
  //   //     this.headerBounds = {};
  //   //     this.currentScrollTop = 0;
  //   //     this.preventReveal = false;
  //   //     this.predictiveSearch = this.querySelector('predictive-search');

  //   //     this.onScrollHandler = this.onScroll.bind(this);
  //   //     this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  //   //     this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //   //     window.addEventListener('scroll', this.onScrollHandler, false);

  //   //     this.createObserver();
  //   //   }

  //   //   disconnectedCallback() {
  //   //     this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //   //     window.removeEventListener('scroll', this.onScrollHandler);
  //   //   }

  //   //   createObserver() {
  //   //     let observer = new IntersectionObserver((entries, observer) => {
  //   //       this.headerBounds = entries[0].intersectionRect;
  //   //       observer.disconnect();
  //   //     });

  //   //     observer.observe(this.header);
  //   //   }

  //   //   onScroll() {
  //   //     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  //   //     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  //   //     if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //   //       if (this.preventHide) return;
  //   //       requestAnimationFrame(this.hide.bind(this));
  //   //     } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //   //       if (!this.preventReveal) {
  //   //         requestAnimationFrame(this.reveal.bind(this));
  //   //       } else {
  //   //         window.clearTimeout(this.isScrolling);

  //   //         this.isScrolling = setTimeout(() => {
  //   //           this.preventReveal = false;
  //   //         }, 66);

  //   //         requestAnimationFrame(this.hide.bind(this));
  //   //       }
  //   //     } else if (scrollTop <= this.headerBounds.top) {
  //   //       requestAnimationFrame(this.reset.bind(this));
  //   //     }

  //   //     this.currentScrollTop = scrollTop;
  //   //   }

  //   //   hide() {
  //   //     this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  //   //     this.closeMenuDisclosure();
  //   //     this.closeSearchModal();
  //   //   }

  //   //   reveal() {
  //   //     this.header.classList.add('shopify-section-header-sticky', 'animate');
  //   //     this.header.classList.remove('shopify-section-header-hidden');
  //   //   }

  //   //   reset() {
  //   //     this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  //   //   }

  //   //   closeMenuDisclosure() {
  //   //     this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  //   //     this.disclosures.forEach(disclosure => disclosure.close());
  //   //   }

  //   //   closeSearchModal() {
  //   //     this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  //   //     this.searchModal.close(false);
  //   //   }
  // }
  // customElements.define('header-menu', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mashvp-cms-video-slider"] && !Shopify.designMode) return;
  try {
    

function unescape(str) {
  let res = str.replace(/&quot;/g, '"');
  res = res.replace(/&lt;/g, '<');
  res = res.replace(/&gt;/g, '>');
  return res;
}

class VideoSlider extends HTMLElement {
  constructor() {
    super();

    this.data = JSON.parse(this.querySelector('#videoSLiderData').innerHTML);
    const parser = new DOMParser();
    this.data.map((slide, index) => {
      slide.video = parser.parseFromString(unescape(slide.video), "text/html").querySelector('video');
      // slide.miniature = parser.parseFromString(slide.miniature, "text/html");
      return slide;
    });

    this.mainVideoCtn = this.querySelector('.main .mediaCtn');

    this.mainTitle = this.querySelector('.text .title');
    this.mainContent = this.querySelector('.text .content');
    this.slides = this.querySelectorAll('.slide');

    this.current = 0;
    this.total = this.data.length;

    this.querySelector('.next').addEventListener('click', () => this.next());
    this.querySelector('.prev').addEventListener('click', () => this.prev());
    this.querySelector('.unmute').addEventListener('click', () => this.mute());

    this.update();
  }

  mute() {
    this.data[this.current].video.muted = !this.data[this.current].video.muted;
    if (this.data[this.current].video.muted) {
      this.querySelector('.unmute .cross').style.display = "block";
    } else {
      this.querySelector('.unmute .cross').style.display = "none";
      // this.querySelector('.unmute .cross').classList.add('hidden');
    }

  }

  next() {
    this.current = (this.current === this.total - 1)? 0 : this.current + 1;
    this.update();
  }

  prev() {
    this.current = (this.current === 0)? this.total - 1 : this.current - 1;
    this.update();
  }

  update() {
    this.querySelector('.unmute .cross').style.display = "block";

    this.mainVideoCtn.innerHTML = '';
    // this.data[this.prev].video.classlist.add();
    // this.data[this.current].video.classlist.add();
    this.mainVideoCtn.append(this.data[this.current].video);
    this.mainTitle.innerHTML = unescape(this.data[this.current].title);
    this.mainContent.innerHTML = unescape(this.data[this.current].text);

    this.slides.forEach((slide, index) => {
      if (index != 2) {
        let curIndex = this.current + index -2;
        curIndex = (curIndex < 0)? this.total + curIndex : curIndex;
        slide.querySelector("img").src = unescape(this.data[curIndex].miniature);
        
        this.data[this.current].video.pause();
      } else {
        setTimeout(() => {
          this.data[this.current].video.play();
        }, 100);
        // console.log(this.data[this.current].video);
      }
    });
  }
  // animate(prev, next) {
  //   prev.classList.add('out');
  //   next.classList.add('in');
  // } 
}

customElements.define("video-slider", VideoSlider);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mashvp-popup"] && !Shopify.designMode) return;
  try {
    

class Popupp extends HTMLElement {
  constructor() {
    super();

    if (sessionStorage.getItem('showPopup') != 'true') {
      this.classList.add('show')
    }
    this.querySelector('.close').addEventListener('click', ()=>this.close()) 
  }

  close() {
    sessionStorage.setItem('showPopup', 'true');
    this.classList.remove('show')
  }

}

customElements.define('pop-up', Popupp);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
